import CanvasLightTheme from 'foundations-theming-base/stable/canvas/light/theme';
import { getDeployedTheme } from '../../utils/getDeployedTheme';
import { getCssVariablesTheme, getUseCssVariables } from '../../utils/localCssVariables';
const LEGACY_THEME_NAME_MAP = {
  trellis: 'trellis',
  canvas: 'canvas',
  classic: 'canvas',
  next: 'trellis',
  pink: 'pink'
};
export const mergeThemeWithOverrides = (baseTheme, overrides) => {
  return Object.assign({}, baseTheme, {
    color: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.color, overrides.color),
    space: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.space, overrides.space),
    borderRadius: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderRadius, overrides.borderRadius),
    borderWidth: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.borderWidth, overrides.borderWidth),
    boxShadow: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.boxShadow, overrides.boxShadow),
    typography: Object.assign({}, baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.typography, overrides.typography)
  });
};
export function convertLegacyThemeName({
  themeName,
  themeMode
}) {
  if (themeName in LEGACY_THEME_NAME_MAP) {
    return {
      themeName: LEGACY_THEME_NAME_MAP[themeName],
      themeMode: themeMode
    };
  }
  return {
    themeName,
    themeMode
  };
}
export const getDefaultTheme = () => {
  return applyThemeOverrides(CanvasLightTheme);
};
function applyThemeOverrides(theme, themeOverrides) {
  if (themeOverrides && Object.keys(themeOverrides).length > 0) {
    theme = mergeThemeWithOverrides(theme, themeOverrides);
  }
  if (getUseCssVariables()) {
    theme = getCssVariablesTheme(theme);
  }
  return theme;
}
const getTheme = async (themeName, themeMode) => {
  if (themeName === 'canvas') {
    if (themeMode === 'light') {
      return Promise.resolve(CanvasLightTheme);
    }
    // @ts-expect-error Pink theme is a fake theme for now
  } else if (themeName === 'pink') {
    if (themeMode === 'light') {
      return (await import('./mock-themes/pink/light/theme')).default;
    }
  } else if (themeName === 'trellis') {
    if (themeMode === 'light') {
      return (await import('../../themes/trellis/light/theme')).default;
    } else if (themeMode === 'dark') {
      return (await import('../../themes/trellis/dark/theme')).default;
    }
  }
  return undefined;
};
export async function getThemeToProvide(themeSettings) {
  const {
    themeName,
    themeMode,
    themeVersion,
    themeOverrides
  } = themeSettings;
  let theme = undefined;
  if (themeVersion.type === 'builtin') {
    theme = await getTheme(themeName, themeMode);
  } else {
    theme = await getDeployedTheme({
      themeName,
      themeMode,
      themeVersion
    });
  }
  if (theme) {
    return applyThemeOverrides(theme, themeOverrides);
  }
  throw new Error('Unsupported theme and mode combination.');
}